import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type {
	CentralInvoiceRecipient,
	CentralInvoiceRecipientWithClient,
	CreateOrUpdateCentralInvoiceRecipientData,
} from "~/modules/billing/api/centralInvoiceRecipient/centralInvoiceRecipientTypes.ts";

export function indexCentralInvoiceRecipientByClient(clientId: string): AxiosApiResponsePromise<CentralInvoiceRecipient[]> {
	return axiosApi.get(`clients/${clientId}/invoice-recipients`);
}

export function indexCentralInvoiceRecipientByCompany(companyId: string): AxiosApiResponsePromise<CentralInvoiceRecipientWithClient[]> {
	return axiosApi.get(`company/${companyId}/invoice-recipients`);
}

export function indexCentralInvoiceRecipients(): AxiosApiResponsePromise<CentralInvoiceRecipient[]> {
	return axiosApi.get(`invoice-recipients`);
}

export function getInvoiceRecipient(clientId: string,
	invoiceRecipientId: string): AxiosApiResponsePromise<CentralInvoiceRecipient> {
	return axiosApi.get(`clients/${clientId}/invoice-recipients/${invoiceRecipientId}`);
}

export function createCentralInvoiceRecipient({ clientId, data }: {
	clientId: string,
	data: CreateOrUpdateCentralInvoiceRecipientData
}): AxiosApiResponsePromise<CentralInvoiceRecipient> {
	return axiosApi.post(`clients/${clientId}/invoice-recipients`, { ...data });
}

export function updateCentralInvoiceRecipient({ clientId, invoiceRecipientId, data }: {
	clientId: string,
	invoiceRecipientId: string,
	data: CreateOrUpdateCentralInvoiceRecipientData
}): AxiosApiResponsePromise<CentralInvoiceRecipient> {
	console.log(data);
	return axiosApi.put(`clients/${clientId}/invoice-recipients/${invoiceRecipientId}`, { ...data });
}

export function deleteCentralInvoiceRecipient({ clientId, invoiceRecipientId }: {
	clientId: string,
	invoiceRecipientId: string
}): AxiosApiResponsePromise<void> {
	return axiosApi.delete(`clients/${clientId}/invoice-recipients/${invoiceRecipientId}`);
}